<template>
  <v-container>
    <v-toolbar flat dark color="transparent">
      <v-toolbar-side-icon>
        <router-link to="/">
          <img src="../../assets/logoWoT.png" height="100px" width="220px" />
        </router-link>
      </v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-row align="center" justify="end">
        <v-toolbar-items class="hidden-sm-and-down">
          <router-link to="/">
            <v-btn text color="white"> Home </v-btn>
          </router-link>
          <router-link to="/news">
            <v-btn text color="white"> News </v-btn>
          </router-link>
          <router-link to="/thing-descriptions">
            <v-btn text color="white"> Thing Descriptions </v-btn>
          </router-link>
          <router-link to="/scenarios">
            <v-btn text color="white"> Scenarios </v-btn>
          </router-link>
          <router-link to="/about">
            <v-btn text color="white"> About </v-btn>
          </router-link>
        </v-toolbar-items>
      </v-row>
      <div class="hidden-md-and-up">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-app-bar-nav-icon v-on="on"></v-app-bar-nav-icon>
          </template>
          <v-list class="responsiveMenu">
            <v-list-item>
              <v-list-item-title><router-link class="full-width" to="/">Home</router-link></v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title><router-link class="full-width" to="/news">News</router-link></v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title><router-link class="full-width" to="/thing-descriptions">Thing Descriptions</router-link></v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title><router-link class="full-width" to="/scenarios">Scenarios</router-link></v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title><router-link class="full-width" to="/about">About</router-link></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
  </v-container>
</template>

<script>
export default {
  name: "Navbar",
};
</script>

<style scoped>
.hidden-md-and-up {
  z-index: 1000; /* Asegura que el menú tenga el z-index más alto */
}

.responsiveMenu {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.full-width {
  display: block;
  width: 100%;
}

.v-list-item-title {
  padding: 0.5rem 1rem; /* Espaciado interno para los elementos del menú */
}

@media (max-width: 800px) {
  .hidden-sm-and-down {
    display: none !important;
  }
  .hidden-md-and-up {
    display: block !important;
  }
}
</style>